import classNames from 'classnames';
import { forwardRef } from 'react';
const emptyStateContainerCss = "ei7o7zl";
const EmptyStateContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(emptyStateContainerCss, props.className)} />;
});
const emptyStateTextCss = "ea7g8gt";
const EmptyStateText = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(emptyStateTextCss, props.className)} />;
});
export { EmptyStateContainer, EmptyStateText };

require("./styles.wyw-in-js.css!=!../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");